var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QTab',_vm._b({class:['sai-tab', { 'show-inactive-indicator': _vm.showInactiveIndicator }],style:(_vm.styleVariables),attrs:{"ripple":false}},'QTab',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }